const Tooltip = () => {

  const onClickOutside = e => {
    const target = e.target
    // Avoid double clicking event
    if (target.classList.contains('tooltip__input')) return false
    if (target.classList.contains('tooltip__label')) {
      const parent = target.parentNode
      const radio = parent.querySelector('.tooltip__input')
      if (radio.checked) {
        // Add little delay to make sure event finished
        setTimeout(() => radio.checked = false, 100)
      }
    } else {
      const radios = document.querySelectorAll('.tooltip__input')
      ;[].forEach.call(radios, radio => radio.checked = false)
    }
  };

  if (document.querySelector('.tooltip')) {
    window.addEventListener('click', onClickOutside)
  }
}

export default Tooltip;



// WEBPACK FOOTER //
// ./scripts/components/Tooltip.js